/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
// @mui
import {
    Box,
    TextField,
    Autocomplete
} from '@mui/material';
// style
import { saveNewAudience, updateSelectedAudience } from '../../../redux/slices/audienceManager';
import {
    tagsBoxStyle,
    allTagChipStyle,
} from '../../../styles/AutocompleteTags';
// redux
import { dispatch, useSelector } from '../../../redux/store';
// constant
import { campaignConst } from '../../../constants/Campaign';

// ----------------------------------------------------------------------------------------------------------

export default function AudienceStatusDropDown() {
    const [getStatusValue, setStatusValue] = useState([]);
    const { newAudience, selectedAudienceData } = useSelector((state) => state.audienceManager);

    useEffect(() => {
        if (selectedAudienceData) {
            const statusValue = campaignConst?.filter((el) => selectedAudienceData?.recepient?.filters?.lead_treatments__status__in?.includes(el.value));
            setStatusValue(statusValue);
        }
    }, [selectedAudienceData]);

    const defaultValues = {
        status: newAudience?.statusNames || getStatusValue || []
    };

    const methods = useForm({
        mode: 'onChange',
        defaultValues,
    });

    const {
        setValue,
        control
    } = methods;

    const handleChange = (event, newValue) => {
        const data = { lead_treatments__status__in: newValue?.map((el) => el.value) };
        setValue('status', newValue[newValue?.length - 1]);
        if (Object.values(selectedAudienceData).length > 0) {
            const updatedCampaign = { ...selectedAudienceData, recepient: { ...selectedAudienceData.recepient, filters: { ...selectedAudienceData.recepient?.filters, ...data } } };
            dispatch(updateSelectedAudience(updatedCampaign));
            return;
        }
        dispatch(saveNewAudience({ lead_treatments__status__in: data, statusNames: newValue }));
    };

    return (
        <Box sx={tagsBoxStyle}>
            <Controller
                name="status"
                control={control}
                render={() => (
                    <Box sx={{ width: '100%' }}>
                        <Autocomplete
                            multiple
                            id="tags-outlined"
                            options={campaignConst}
                            value={newAudience.statusNames || getStatusValue || []}
                            getOptionLabel={(option) => option.title}
                            onChange={(event, newValue) => handleChange(event, newValue)}
                            sx={allTagChipStyle}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label=""
                                    placeholder="Status"
                                />
                            )}
                        />
                    </Box>
                )}
            />
        </Box>
    );
}